:host {
  display: block;
}

.paragraph-events {
  display: flex;
  flex-direction: column;
  background-color: var(--color-off-white);
  margin-bottom: var(--s-1);
}

.events-header {
  height:  auto;
  margin-bottom: var(--s-1);
}

.events-title {
  background-color: #333;
  color: #FFF;
  text-transform: uppercase;
  overflow-wrap: break-word;
  /*min-height: 50px;*/
  padding: var(--s-1);
  font-size: var(--s0);
}

.calendar-content {
  flex: 1;
}

.calendar-row {
  /*font-size: 18px;*/
  /*margin-bottom: 20px;*/
  padding: var(--s0) 0;
  border-bottom: 1px solid var(--color-lighter-gray);
  /*border: 1px solid #000;*/
  display: flex;
}

.caledar-dates {
  /*margin-right: 20px;*/
  margin-right: var(--s-1);
  /*min-width: 50px;*/
  min-width: var(--s4);
}

.calendar-content {
  display: flex;
  flex-direction: column;

}

.month {
  /*font-size: 0.75em;*/
  font-size: var(--s-1);
  background-color: var(--color-cwru-blue);
  color: #fff;
  text-align: center;
  padding: 0 var(--s-2);
}
.day {
  border: 1px solid var(--color-lighter-gray);
  border-top: none;
  border-bottom: none;
  background-color: white;
  text-align: center;
  /*font-size: 25px;*/
  font-size: var(--s1);
  line-height: 1.4;
  display: block;
  color: #535353;
}
.year {
  font-size: var(--s-1);
  border: 1px solid var(--color-lighter-gray);
  border-top: none;
  background-color: white;
  text-align: center;
  /*font-size: 25px;*/
  line-height: 1.4;
  display: block;
  color: #535353;
}

.calendar-heading-descr {
  /*margin-top: -4px;*/
}

.calendar-heading {
  margin-bottom:  var(--s-1);
}

.calendar-heading a {
  text-decoration: none;
  color: var(--color-link-blue);
  font-weight: var(--font-weight-bold);
 /* font-size: var(--s1);*/
}

.news-article-date {
  font-size: var(--s-1);
}

.calendar-descr {
  max-height: calc(var(--line-height) * 2);
  text-overflow: ellipsis;
  overflow: hidden;
}

.events-footer {
  height: auto;
  background-color: var(--color-cwru-blue);
  text-align: center;
}

.button-block-blue {
  display: block;
  width: 100%;
  vertical-align: middle;
  padding: 9px;
  color: #FFF;
  font-weight: var(--font-weight-bold);
  text-decoration: none;
}